<template>
    <div id="app"  @contextmenu.prevent>
        <router-view />
    </div>
</template>


<script>
export default {
  data() {
    return {
      currentVersion: process.env.VUE_APP_VERSION, // The current version of your app
    };
  },
  created() {
    this.checkForUpdates();
    setInterval(this.checkForUpdates, 60000); // Check every 60 seconds
  },
  methods: {
    async checkForUpdates() {
  
      try {

       
        await this.$store.dispatch("getVersionsWeb");
      
        
        let version  = this.$store.state.web_version_api;
       
        if (version !== this.currentVersion) {
         
            window.location.reload();
         
        }
      } catch (error) {
        console.error('Failed to check for updates:', error);
      }
    },
  },
};
</script>